import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"

const getInitials = (value) => {
  if (!value) return "U"
  const trimmed = value.includes("@") ? value.split("@")[0] : value
  const parts = trimmed.replace(/[^a-zA-Z0-9 ]/g, " ").trim().split(/\s+/)
  if (parts.length === 0) return "U"
  return parts.slice(0, 2).map((part) => part[0]).join("").toUpperCase()
}

const LinkedinProfileInfo = ({ displayName, handleLabel, avatarUrl }) => {
  const initials = getInitials(displayName || handleLabel)

  if (!displayName && !handleLabel) return null

  return (
    <div className="flex items-center gap-3">
      <Avatar>
        {avatarUrl ? (
          <AvatarImage src={avatarUrl} alt={displayName} />
        ) : (
          <AvatarFallback className="text-xs font-semibold">
            {initials}
          </AvatarFallback>
        )}
      </Avatar>
      <div>
        <div className="text-sm font-semibold">{displayName}</div>
        <div className="text-xs text-muted-foreground">Publish to Anyone</div>
      </div>
    </div>
  )
}

export default LinkedinProfileInfo
